import { render, staticRenderFns } from "./nuevoRegistro.vue?vue&type=template&id=330f62ba&scoped=true&lang=html&"
import script from "./nuevoRegistro.vue?vue&type=script&lang=js&"
export * from "./nuevoRegistro.vue?vue&type=script&lang=js&"
import style0 from "./nuevoRegistro.vue?vue&type=style&index=0&id=330f62ba&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330f62ba",
  null
  
)

export default component.exports